import { BreachPathDetailsTransitionSideMenuDataType } from '../types';
import { BaseWebComponentTranslator } from 'apps/webcomponents/src/framework/BaseWebComponentTranslator';
import { html, TemplateResult } from 'lit';
import { DEVICES_CLASS, AffectedDeviceType } from 'apps/webcomponents/src/riskManagement/common/constants';
import { BreachPathNode } from '../../breachPathDetails/types';

export function headerIconRenderer(data: BreachPathNode): TemplateResult {
  let borderColor = 'transparent';
  
  if (data.type === AffectedDeviceType.EC2_INSTANCE) {
    borderColor = 'var(--red-alert-500-severe)';
  } else if (data.type === AffectedDeviceType.EC2_NETWORK_ACL || data.type === AffectedDeviceType.NETWORK_NETWORK_SECURITY_GROUPS) {
    borderColor = 'var(--orange-alert-chart-100)';
  } else if (data.type === AffectedDeviceType.VPCINTERNET_GATEWAY) {
    borderColor = 'var(--yellow-alert-050)';
  }

  return html`
    <div class="node-wrapper" style="border-color: ${borderColor};">
      <gz-breach-path-graph-icon
        name="${DEVICES_CLASS.get(data.type)}"
        color="var(--white-layout-300-primary)"
        size="24"
      ></gz-breach-path-graph-icon>
    </div>
  `;
}

export function sourceResourceNameRenderer(data: BreachPathDetailsTransitionSideMenuDataType): string {
  return data.source.name || '-';
}

export function targetResourceNameRenderer(data: BreachPathDetailsTransitionSideMenuDataType): string {
  return data.target.name || '-';
}

export function sourceResourceTypeRenderer(data: BreachPathDetailsTransitionSideMenuDataType): string {
  return BaseWebComponentTranslator.getInstance().getDeviceTypes(data.source.type) || '-';
}

export function targetResourceTypeRenderer(data: BreachPathDetailsTransitionSideMenuDataType): string {
    return BaseWebComponentTranslator.getInstance().getDeviceTypes(data.target.type) || '-';
}
